import en from './en'
import ua from './ua'

import store from '@/store'
const fallBackLang = 'ua'
const messages = {
  en,
  ua,
}
const getBrowserLocale = () => {
  const navigatorLocale =
    navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator.language

  if (!navigatorLocale) return undefined

  return navigatorLocale.trim().split('-').shift()
}

const getStoreLocale = store.getters['app/getSelectedLocale']
const defaultLanguage = getStoreLocale ? getStoreLocale : ['ua', 'en'].includes(getBrowserLocale()) ? getBrowserLocale() : fallBackLang
store.dispatch('app/setDefaultLocale', defaultLanguage)

export { messages, defaultLanguage }
